/**
 * Automatically imports all the modules and exports as a single module object
 */
const requireModule = require.context('.', false, /\.routes\.js$/);
const modules = [];

requireModule.keys().forEach((filename) => {
  // create the module name from fileName
  // remove the store.js extension
  const moduleArray =
    requireModule(filename).default || requireModule(filename);

  modules.push(...moduleArray);
});

export default modules;
